import React, { useEffect, useState  } from "react";
import { MapContainer, TileLayer, GeoJSON, LayersControl,ScaleControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "../TsunamiThreat.css";
import { MapHomeControl, MapInfoControl, MapLegendControl } from "../../../../common/MapControls/MapControls";
const INITIAL_VIEW_STATE = {
    longitude: 125.7275,
    latitude: -8.8742,
    zoom: 9,
};

const RiskInformation = () => {
  const [boundaryData, setBoundaryData] = useState(null);

  
  useEffect(() => {
    // Load the GeoJSON boundary data
    fetch("/DATA/OSMbased_adm1_boundary.json")
      .then((response) => response.json())
      .then((data) => setBoundaryData(data))
      .catch((error) => console.error("Error loading boundary data:", error));
  }, []);
// Color mapping fro Risk
const getColorForRisk = (risk) => {
    switch (risk) {
        case "Low":
            return "green";
        case "Medium":
            return "yellow";
        case "High":
            return "red";
        default:
            return "gray"; // Default color for unrecognized subdivisions
    }
};
 // Display Risk Data - START
        const [risk_, setRisk_] = useState(null);
        const [featreRisk, setfeatreRisk] = useState(null);
        useEffect(() => {
            fetch("/Earthquake/FeZn_Deficiency_Risk_Hollow.geojson")
            .then((response) => response.json())
            .then((data) => setRisk_(data))
            .catch((error) => console.error("Error loading boundary data:", error));
        }, []);
        const riskFeature = (feature, layer) => {
            layer.on({
                mouseover: () => {
                    setfeatreRisk(` <table className="table-popup "> <tbody>
                        <tr className="centeralign">
                            <th colspan="2"><h6>Deficiency Risk Information</h6></th>
                        </tr>
                        <tr>
                            <th>Name : </th>
                            <td>${feature.properties.Name}</td>
                        </tr>
                        <tr>
                            <th>Risk : </th>
                            <td>${feature.properties.feznrisk}</td>
                        </tr>
                        <tr>
                            <th>Class : </th>
                            <td>${feature.properties.Class}</td>
                        </tr>
                        </tbody> </table>`)
                },
                mouseout: () => {
                    setfeatreRisk(null);
                }
            });
        };
// Display Risk Data - END
const Legend = () => (
    <MapLegendControl
        sections={[{
            title: "Deficiency Risk Hollow",
            items: [
                { label: "Low Risk", color: "Green" },
                { label: "Medium Risk", color: "Yellow" },
                { label: "High Risk", color: "Red" },
            ],
        }]}
    />
);
  return (
    <div className="wind-speed-cyclone-container">
      <div className="map-container-WindSpeedCyclone">
        <MapContainer
          center={[INITIAL_VIEW_STATE.latitude, INITIAL_VIEW_STATE.longitude]}
          attributionControl={false}
          zoom={INITIAL_VIEW_STATE.zoom}
          style={{ width: "100%", height: "650px" }}
        >
          <MapHomeControl />
          <MapInfoControl text="Tsunami risk information for coastal areas of Timor-Leste." />
          {/* Layer toggle control */}
            <LayersControl position="topright">
                <LayersControl.BaseLayer name="White Theme" checked>
                    <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                </LayersControl.BaseLayer>
                
                {featreRisk && (
                    <div
                    className="hover-box"
                    dangerouslySetInnerHTML={{ __html: featreRisk }}
                    />
                )}
                <LayersControl.Overlay name="Deficiency Risk Hollow" checked>
                    {risk_ && (
                    <GeoJSON data={risk_}
                        style={(feature) => {
                            const risk = feature.properties?.Class || "default";
                            const color = getColorForRisk(risk); // Get the color
                            return { color:"black", opacity: 0.5, weight: 2, fillOpacity: 0.8, fillColor : color };
                        }}
                        onEachFeature={riskFeature}
                    />
                    )}
                </LayersControl.Overlay>
            </LayersControl>
            {/* Render the boundary GeoJSON layer if data is loaded */}
            {boundaryData && (
                <GeoJSON
                    data={boundaryData}
                    style={{
                        color: "#000000",
                        weight: 1,
                        opacity: 0.8,
                        dashArray: 6,
                        fillOpacity: 0,
                    }}
                />
            )}
            <ScaleControl position="bottomleft"/>
            <Legend position="bottomright" />
        </MapContainer>
      </div>
    </div>
  );
};

export default RiskInformation;
